import React from "react";
import { useTranslation } from 'react-i18next';
import CalendarComponent from "../CalendarComponent";
import Upcomingsection from "./Upcomingsection";
import Setpapply from "./Setpapply";
const Hellosection = ({sectionSessionRef,setpapplydata}) => {
  const { t, i18n } = useTranslation()

  return (
    <section className="upcoming-session-section" id="upcoming_section" ref={sectionSessionRef}>
    <div className="container">
        <div className="calender-inner-wrapper d-flex">
            <div className="calender-view registration-content">

  <Setpapply setpapplydata={setpapplydata} />
            </div>
        <Upcomingsection />
        </div>
    </div>
</section>
  );
};

export default Hellosection;